import { render, staticRenderFns } from "./ErrorsMessages.vue?vue&type=template&id=18dcf2f4&"
import script from "./ErrorsMessages.vue?vue&type=script&lang=js&"
export * from "./ErrorsMessages.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports